module.exports = __webpack_public_path__ + "static/media/whatsapp.e94f6491.svg";